import MallGroupApi from "@/api/zfb/mall_group";
import RemarkTemplateApi from "@/api/zfb/remark_template";
import { COU_PurchasedOrderRemark } from "@/utils/co_util";
// 获取店铺列表
async function GetMallList(GroupId) {
  return await MallGroupApi.GetMallListByGroupId(1, 100, GroupId);
}

const optionList = [
  { label: "采购单号", value: "shopRemarkOrderSn" },
  { label: "采购账号", value: "shopRemarkBuyerAccount" },
  { label: "采购金额", value: "shopRemarkPrice" },
  { label: "采购利润", value: "shopRemarkProfit" },
  { label: "采购店铺", value: "shopRemarkShop" },
];

// 判断是否选择了店铺
const isSelectMall = (relationId) => (relationId ? "" : "当前没有选择店铺");

// 获取订单备注模板
async function GetMallRemarkTemplate(This) {
  const errMsg = isSelectMall(This.relationId);
  if (errMsg && !This.onlyMall) return This.$message.warning(errMsg);
  const { remarkTemplate, msg, success } = await RemarkTemplateApi.GetMallRemarkTemplate(This.relationId);
  const mallName = This.mallName;
  if (!success && !msg?.includes("未找到店铺设置")) {
    return This.$message.warn(msg);
  } else This.$message.success(`已获取【${mallName}】店铺订单设置`);
  This.value = [];
  This.flagValue = 0;
  This.remarkType = 1;
  This.sendGiftTogether = 0;
  This.purchasedOrderRemarkType = 0;
  if (remarkTemplate) {
    for (let key in remarkTemplate) {
      // 接口返回的首字母是大写, 保存时首字母需要小写, 所以首字母转成小写
      const newKey = key.replace(key[0], key[0].toLocaleLowerCase());
      const isSelected = optionList.find((item) => item.value === newKey) && remarkTemplate[key];
      isSelected && This.value.push(newKey);
    }
    This.flagValue = remarkTemplate.ShopRemarkFlag;
    This.remarkType = remarkTemplate.RemarkType;
    This.sendGiftTogether = remarkTemplate.SendGiftTogether;
    This.purchasedOrderRemarkType = remarkTemplate.PurchasedOrderRemarkType;
  }
}

// 保存订单配置
async function SaveMallRemarkTemplate(This) {
  const errMsg = isSelectMall(This.relationId);
  if (errMsg && !This.onlyMall) return This.$message.warning(errMsg);
  const params = {};
  for (let item of optionList) {
    params[item.value] = This.value.includes(item.value) ? 1 : 0;
  }
  params.shopRemarkFlag = This.flagValue;
  params.shopRemarkProfitRate = 0; // 采购利润率不需要展示
  params.remarkType = This.remarkType; // 订单备注位置
  params.sendGiftTogether = This.sendGiftTogether; // 赠品是否要自动发货掉
  params.purchasedOrderRemarkType = This.purchasedOrderRemarkType; // 设置采购订单备注的内容
  var { msg, success } = await RemarkTemplateApi.SaveMallRemarkTemplate(
    This.relationId,
    params,
    This.relationId ? false : true
  );
  This.$message[success ? "success" : "warn"](msg);
  // 将purchasedOrderRemarkType 保存到本地, 以后采购订单的时候先从本地获取, 如果没有才从接口中获取(减少接口调用次数)
  savePurchasedOrderRemarkTypeToLocal(This.purchasedOrderRemarkType, This.relationId);
}
// 如果是 使用买家的备注 值为0 存到本地是字符串的形式取出所以没有关系,无需考虑0的boolean
function savePurchasedOrderRemarkTypeToLocal(purchasedOrderRemarkType, relationId) {
  localStorage.setItem(COU_PurchasedOrderRemark(relationId), purchasedOrderRemarkType);
}

export default {
  GetMallList,
  optionList,
  GetMallRemarkTemplate,
  SaveMallRemarkTemplate,
};
